module.exports = __webpack_public_path__ + "img/5.877ca039.jpg";